@let enableSlider = enableForTotal();
@let _optionGroup = optionGroup()!;
@if (showMarketHelp) {
    <ms-market-help [optionGroup]="_optionGroup" [eventHelpText]="eventHelpText" />
}

@if (!displayLineValueInSquares) {
    <div class="option-group-container over-under-container triple" [style.--option-group-rows]="visibleOptionGroups()">
        <div class="option-group-header">
            <span></span> <span>{{ _optionGroup.parameterTranslations?.columnOver }}</span>
            <span>{{ _optionGroup.parameterTranslations?.columnUnder }}</span>
        </div>
        <ng-container *rxFor="let group of visibleOptionGroups$; trackBy: trackGroup">
            <div class="attribute-key">
                {{ group.attribute }}
                @if (group.templateId && isMarketPromoted(group.optionGroupId, group.templateId)) {
                    <ms-promotion-badge class="no-title" />
                }
            </div>
            <ng-container *ngTemplateOutlet="commonMsOptions; context: { group }" />
        </ng-container>
    </div>
} @else {
    <div
        class="option-group-container over-under-container double"
        [class.slider-over-under-container]="enableSlider"
        [style.--option-group-rows]="visibleOptionGroups()">
        @if (!enableSlider || (!isSliderVisibleWithoutShowMore && expanded)) {
            <div class="option-group-header">
                <span>{{ _optionGroup.parameterTranslations?.columnOver }}</span>
                <span>{{ _optionGroup.parameterTranslations?.columnUnder }}</span>
            </div>
        }
        <ng-container *rxFor="let group of visibleOptionGroups$; trackBy: trackGroup">
            <ng-container *ngTemplateOutlet="commonMsOptions; context: { group }" />
        </ng-container>
    </div>
    @if (enableSlider && !isInSheetView && (isSliderVisibleWithoutShowMore || !expanded)) {
        <ms-market-slider
            class="slider"
            [steps]="sliderSteps"
            [centerValue]="centerValue"
            [isDisabled]="disableSlider"
            [identityKey]="_optionGroup.id"
            (selectedValueChange)="setSliderCurrentValue($event)" />
    }
}

@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}

<ng-template #commonMsOptions let-group="group">
    @for (option of group.options; track option.id) {
        <ms-option
            [option]="option"
            [tracking]="{ source: tracking, moduleType: trackingModuleType }"
            [optionGroup]="_optionGroup"
            [event]="event"
            [showPromoBadge]="!!crmPromoIdsMap.options[option.id]"
            [sourceOfPick]="sourceOfPick"
            [betDetails]="betDetails"
            [sliderValue]="{ currentValue: (currentValue$ | async) || 0, centerValue: centerValue }"
            [expanded]="!isSliderVisibleWithoutShowMore && expanded" />
    }
</ng-template>
